<style scoped>

</style>
<template>
  <v-overlay
    :absolute="true"
    :opacity="opacity"
    :value="value"
  >
    <v-progress-linear
      color="primary"
      indeterminate
      rounded
      height="6"
      style="min-width: 300px; max-width: 600px"
    />
  </v-overlay>
</template>
<script>
  export default {
    props: {
      value: {
        type: Boolean,
        required: true,
        default: false
      },
      opacity: {
        type: Number,
        default: 0.05
      }
    }
  }
</script>
